import React, { useState, useEffect } from "react";
import { Button, Input, Text } from "components";
import { getAuthUrl } from "utils/api-util";
import CustomerCreation from "modals/CustomerCreation";
import { useNavigate } from "react-router-dom";
import { clearCustomer } from "utils/clearCustomer";
import { ClipLoader } from "react-spinners";
import axios from "axios";
import { useSelector } from "react-redux";

const AddTenantSummary = ({
  makeTabActive,
  //  setIsFormDirty
}) => {
  // Get the user
  const user = useSelector((state) => state.auth.userData);
  const navigate = useNavigate();

  // Check if just a building is being created
  const isCreateNewBuilding = localStorage.getItem("createNewBuilding");

  // contact information
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [province, setProvince] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [country, setCountry] = useState("");
  const [customerType, setCustomerType] = useState("ENERGY_COMPANY");
  const [error, setError] = useState("");
  const [isOpen, setIsSubmittedSuccessfully] = useState(false);
  // const [customerInfo, setCustomerInfo] = useState(null);

  // Building Information
  const [contactName, setContactName] = useState("");
  const [contactPhoneNumber, setContactPhoneNumber] = useState("");
  const [contactEmailAddress, setContactEmailAddress] = useState("");
  const [numberOfApartments, setNumberOfApartments] = useState("");
  const [bulkMeterNumber, setBulkMeterNumber] = useState("");
  const [bulkMeterAccountNumber, setBulkMeterAccountNumber] = useState("");
  // const [buildingInfo, setBuildingInfo] = useState(null);

  // IMID Device
  const [deviceId, setDeviceId] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [version, setVersion] = useState("");
  const [macAddress, setMacAddress] = useState("");
  const [protocol, setProtocol] = useState("COMMUNICATION_INTERFACE_MQTT");
  const [customerId, setCustomerId] = useState("");
  const imidExists = JSON.parse(localStorage.getItem("isImidChecked"));
  // const [imid, setImid] = useState(null);

  // Meter Information
  const [meter, setMeter] = useState([]);

  // Tenant Information
  const [tenant, setTenant] = useState([]);
  const [updatedTenant, setUpdatedTenant] = useState([]);
  const [showTenantData, setShowTenantData] = useState([]);

  // Check if any item is null
  useEffect(() => {
    // Ensure tenant is an array before processing
    if (!Array.isArray(tenant)) {
      console.error("tenant is not a valid array");
      return;
    }

    // Transform the tenant array
    const updatedTenant = tenant.map((tenantItem) => {
      // Check if all values in the object are empty strings
      const isAllValuesEmpty = Object.values(tenantItem).every(
        (value) => value === ""
      );

      // Return null if all values are empty, otherwise return the object as is
      return isAllValuesEmpty ? null : tenantItem;
    });

    // Update the state with the transformed array
    setShowTenantData(updatedTenant);
  }, [tenant]); // Only run when tenant changes

  const payloadId = localStorage.getItem("customerId");

  const onClose = () => {
    setIsSubmittedSuccessfully(false);
    // setIsFormDirty(true);
    clearCustomer();
    if (user?.role === "ROLE_SUPER_ADMIN") {
      navigate("/admin-dashboard");
    } else if (user?.role === "ROLE_ADMIN") {
      navigate("/buildings");
    }
  };

  const token = window.localStorage.getItem("token");
  const baseUrl = getAuthUrl();
  const [isLoading, setIsLoading] = useState(false);

  // Get all values from localStorage
  useEffect(() => {
    const customer = JSON.parse(localStorage.getItem("customerInfo"));
    if (customer) {
      // setCustomerInfo(customer);
      setName(customer?.name);
      setPhoneNumber(customer?.phoneNumber);
      setEmailAddress(customer?.emailAddress);
      setCity(customer?.city);
      setProvince(customer?.province);
      setPostalCode(customer?.postalCode);
      setCountry(customer?.country);
      setCustomerType(customer?.customerType);
      setAddress(customer?.address);
    }
  }, []);

  useEffect(() => {
    // if (user?.role === "ROLE_SUPER_ADMIN") {
    const building = JSON.parse(localStorage.getItem("buildingInfo"));
    if (building) {
      setContactName(building?.contactName);
      setContactPhoneNumber(building?.contactPhoneNumber);
      setContactEmailAddress(building?.contactEmailAddress);
      setCity(building?.city);
      setProvince(building?.province);
      setPostalCode(building?.postalCode);
      setCountry(building?.country);
      setAddress(building?.address);
      setBulkMeterAccountNumber(building?.bulkMeterAccountNumber);
      setBulkMeterNumber(building?.bulkMeterNumber);
      setNumberOfApartments(building?.numberOfApartments);
    }
    // } else if (user?.role === "ROLE_ADMIN") {
    //   const building = JSON.parse(localStorage.getItem("buildingAdminInfo"));
    //   if (building) {
    //     setContactName(building?.contactName);
    //     setContactPhoneNumber(building?.contactPhoneNumber);
    //     setContactEmailAddress(building?.contactEmailAddress);
    //     setCity(building?.city);
    //     setProvince(building?.province);
    //     setPostalCode(building?.postalCode);
    //     setCountry(building?.country);
    //     setAddress(building?.address);
    //     setBulkMeterAccountNumber(building?.bulkMeterAccountNumber);
    //     setBulkMeterNumber(building?.bulkMeterNumber);
    //     setNumberOfApartments(building?.numberOfApartments);
    //   }
    // }
  }, []);

  useEffect(() => {
    if (user?.role === "ROLE_SUPER_ADMIN") {
      const imidDevice = JSON.parse(localStorage.getItem("imidDevices"));
      if (imidDevice) {
        // setImid(imidDevice);
        setDeviceId(imidDevice?.deviceId);
        setSerialNumber(imidDevice?.serialNumber);
        setVersion(imidDevice?.version);
        setMacAddress(imidDevice?.macAddress);
        setProtocol(imidDevice?.protocol);
        setCustomerId(imidDevice?.customerId);
      }
    } else if (user?.role === "ROLE_ADMIN") {
      const imidDevice = JSON.parse(localStorage.getItem("imidAdminDevices"));
      if (imidDevice) {
        // setImid(imidDevice);
        setDeviceId(imidDevice?.deviceId);
        setSerialNumber(imidDevice?.serialNumber);
        setVersion(imidDevice?.version);
        setMacAddress(imidDevice?.macAddress);
        setProtocol(imidDevice?.protocol);
        setCustomerId(imidDevice?.customerId);
      }
    }
  }, []);

  useEffect(() => {
    if (user?.role === "ROLE_SUPER_ADMIN") {
      const addMetersFormData = JSON.parse(
        localStorage.getItem("addMetersFormData")
      );
      if (addMetersFormData) {
        setMeter(addMetersFormData);
      }
    } else if (user?.role === "ROLE_ADMIN") {
      const addMetersFormData = JSON.parse(
        localStorage.getItem("addAdminMetersFormData")
      );
      if (addMetersFormData) {
        setMeter(addMetersFormData);
      }
    }
  }, []);

  // thi is where the issue is
  useEffect(() => {
    // if (user?.role === "ROLE_SUPER_ADMIN") {
    const tenantData = JSON.parse(localStorage.getItem("tenantData"));
    if (tenantData) {
      setTenant(tenantData);
    }
    // } else if (user?.role === "ROLE_ADMIN") {
    //   const tenantData = JSON.parse(localStorage.getItem("adminTenantData"));
    //   if (tenantData) {
    //     setTenant(tenantData);
    //   }
    // }
  }, []);

  // Prepare the payload for submission
  const data = {
    customer: isCreateNewBuilding
      ? payloadId
      : {
          name: name,
          phoneNumber: phoneNumber,
          emailAddress: emailAddress,
          address: address,
          city: city,
          province: province,
          postalCode: postalCode,
          country: country,
          customerType: customerType,
        }, // this checks if the user is just trying to create a new building or a customer
    building: {
      contactName: contactName,
      contactPhoneNumber: contactPhoneNumber,
      contactEmailAddress: contactEmailAddress,
      address: address,
      city: city,
      province: province,
      postalCode: postalCode,
      country: country,
      numberOfApartments: numberOfApartments,
      bulkMeterNumber: bulkMeterNumber,
      bulkMeterAccountNumber: bulkMeterAccountNumber,
    },
    imid: {
      isExists: imidExists,
      deviceId: deviceId,
      customerId: customerId, // Assuming customerId is available in customerInfo
      serialNumber: serialNumber,
      version: version,
      macAddress: macAddress,
      protocol: protocol,
      deviceStatus: "ENABLED",
    },
    apartment: meter.map((m, index) => ({
      meter: {
        isExists: m.isChecked,
        deviceId: m.deviceId,
        deviceAddress: m.deviceAddress,
        tariff: m.tariff,
        deviceModel: m.deviceModel,
        deviceStatus: "ENABLED",
      },
      tenant: showTenantData[index]
        ? {
            name: showTenantData[index].tenantName,
            phoneNumber: showTenantData[index].tenantPhoneNumber || null,
            emailAddress: showTenantData[index].tenantEmailAddress,
            billingStartDate: showTenantData[index].billingStartDate,
          }
        : null,
    })),
  };

  let url = `${baseUrl}/customer/details`;

  if (user?.role === "ROLE_ADMIN") {
    url = `${baseUrl}/building`;
  }

  // send data to server
  const handleSubmit = async (e) => {
    e.preventDefault();

    // setIsSubmittedSuccessfully(true);
    setError("");

    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    if (user?.role === "ROLE_SUPER_ADMIN" && isCreateNewBuilding) {
      config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          customerId: payloadId,
        },
      };
    }

    try {
      setIsLoading(true);
      // revert to default settiings

      const res = await axios.post(url, data, config);
      console.log("res:", res, "res");
      const dataFromServer = res.data;
      if (dataFromServer?.status === "SUCCESS") {
        setIsSubmittedSuccessfully(true);
      } else {
        setIsSubmittedSuccessfully(false);
        setError(dataFromServer?.message);
      }

      setIsLoading(false);
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  };

  const goBack = () => {
    if (isCreateNewBuilding) {
      makeTabActive(4);
      return;
    }
    if (user?.role === "ROLE_SUPER_ADMIN") {
      makeTabActive(5);
    } else if (user?.role === "ROLE_ADMIN") {
      makeTabActive(4);
    }
  };
  const cancel = () => {
    // clearCustomer();

    localStorage.removeItem("customerInfo");
    localStorage.removeItem("buildingInfo");
    localStorage.removeItem("isImidChecked");
    localStorage.removeItem("isAddBuildingChecked");
    localStorage.removeItem("imidDevices");
    localStorage.removeItem("tenantData");
    localStorage.removeItem("addMetersFormData");
    localStorage.removeItem("isMeterChecked");
    localStorage.removeItem("customerId");

    if (user?.role === "ROLE_SUPER_ADMIN") {
      navigate("/admin-dashboard");
    } else if (user?.role === "ROLE_ADMIN") {
      navigate("/buildings");
    }
  };

  useEffect(() => {
    // loop through the tenant array, if any of them is empty, ignore it
    const filteredData = tenant.filter(
      (item) =>
        item.tenantName && item.tenantEmailAddress && item.billingStartDate
    );
    setUpdatedTenant(filteredData);
  }, [tenant]);

  return (
    <div>
      {isOpen && (
        <CustomerCreation
          isCreateNewBuilding={isCreateNewBuilding}
          isOpen={isOpen}
          onClose={onClose}
        />
      )}
      <form className="mt-4">
        {!isCreateNewBuilding && (
          <>
            <Text className="font-bold text-[18px]">Customer Information</Text>
            <div className="customer-form-wrapper mb-4">
              <div>
                <Input
                  wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
                  className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
                  labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
                  name="user-name"
                  value={name}
                  disabled={true}
                  onChange={(e) => setName(e.target.value)}
                  labelText="Company/Customer Name"
                ></Input>
                <Input
                  wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
                  className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
                  labelClass="relative text-sm text-gray-500 dark:text-blue-500 peer-focus:dark:text-blue-500"
                  name="emailaddress"
                  value={emailAddress}
                  disabled={true}
                  onChange={(e) => setEmailAddress(e.target.value)}
                  labelText="Email Address"
                  required={true}
                ></Input>
                <Input
                  wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
                  className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
                  labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
                  name="phonenumber"
                  value={phoneNumber}
                  maxLength={11}
                  disabled={true}
                  type="number"
                  labelText="Phone Number"
                ></Input>
                <Input
                  wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
                  className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
                  labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
                  name="Address"
                  value={address}
                  disabled={true}
                  onChange={(e) => setAddress(e.target.value)}
                  labelText="Address"
                ></Input>

                <Input
                  wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
                  className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
                  labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
                  name="City"
                  value={city}
                  disabled={true}
                  onChange={(e) => setCity(e.target.value)}
                  labelText="City"
                ></Input>
              </div>
              <div>
                <Input
                  wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
                  className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
                  labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
                  name="province"
                  value={province}
                  disabled={true}
                  onChange={(e) => setProvince(e.target.value)}
                  labelText="Province"
                ></Input>
                <Input
                  wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
                  className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
                  labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
                  name="Zip Code"
                  value={postalCode}
                  type="text"
                  disabled={true}
                  onChange={(e) => setPostalCode(e.target.value)}
                  labelText="Zip Code"
                ></Input>
                <Input
                  wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
                  className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
                  labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
                  name="Country"
                  value={country}
                  disabled={true}
                  onChange={(e) => setCountry(e.target.value)}
                  labelText="Country"
                ></Input>
                <div className=" w-full ">
                  <select
                    value={customerType}
                    className="w-full text-sm bg-gray_100 border-[1px] text-[16px] text-gray_600 font-semibold outline-none border-light_blue_800 font-montserrat h-[66px] md:h-[auto] mt-[25px] rounded-[10px] py-[11px]"
                  >
                    <option value="ENERGY_COMPANY">Energy Company</option>
                  </select>
                </div>
              </div>
            </div>
          </>
        )}
        <Text className="font-bold text-[18px]">Building Information</Text>
        <div className="customer-form-wrapper mb-4">
          <div>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name="Number of Apartments"
              disabled={true}
              type="number"
              labelText="Number of Apartments"
              value={numberOfApartments}
              onChange={(e) => setNumberOfApartments(e.target.value)}
            ></Input>

            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name="address"
              disabled={true}
              type="text"
              labelText="Address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            ></Input>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name="Bulk Meter"
              disabled={true}
              type="number"
              labelText="Bulk Meter"
              value={bulkMeterNumber}
              onChange={(e) => setBulkMeterNumber(e.target.value)}
            ></Input>

            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              disabled={true}
              name="Contact Name"
              labelText="Contact Name"
              value={contactName}
              onChange={(e) => setContactName(e.target.value)}
            ></Input>

            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name="Bulk Meter Account"
              disabled={true}
              type="number"
              labelText="Bulk Meter Account"
              value={bulkMeterAccountNumber}
              onChange={(e) => setBulkMeterAccountNumber(e.target.value)}
            ></Input>

            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              disabled={true}
              name="City"
              labelText="City"
              value={city}
              onChange={(e) => setCity(e.target.value)}
            ></Input>
          </div>
          <div>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              disabled={true}
              name="Postal Code"
              labelText="Postal Code"
              value={postalCode}
              onChange={(e) => setPostalCode(e.target.value)}
            ></Input>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name="Country"
              disabled={true}
              type="text"
              labelText="Country"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
            ></Input>

            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name="State/Province"
              disabled={true}
              type="text"
              labelText="State/Province"
              value={province}
              onChange={(e) => setProvince(e.target.value)}
            ></Input>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              disabled={true}
              name="email"
              labelText="Contact Email Address"
              value={contactEmailAddress}
              onChange={(e) => setContactEmailAddress(e.target.value)}
            ></Input>

            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name="phonenumber"
              disabled={true}
              type="number"
              labelText="Contact Phone Number"
              value={contactPhoneNumber}
              onChange={(e) => setContactPhoneNumber(e.target.value)}
            ></Input>
          </div>
        </div>
        <Text className="font-bold text-[18px]">Add Imid Device</Text>
        <div className="customer-form-wrapper mb-4">
          <div>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name="device-id"
              value={deviceId}
              onChange={(e) => setDeviceId(e.target.value)}
              labelText="Device Id"
            ></Input>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-blue-500 peer-focus:dark:text-blue-500"
              name="serialNumber"
              value={serialNumber}
              disabled={true}
              onChange={(e) => setSerialNumber(e.target.value)}
              labelText="Serial Number"
              required={true}
            ></Input>
          </div>
          <div>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name="version"
              value={version}
              onChange={(e) => setVersion(e.target.value)}
              disabled={true}
              type="text"
              labelText="Version"
            ></Input>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name="Mac-Address"
              value={macAddress}
              onChange={(e) => setMacAddress(e.target.value)}
              disabled={true}
              labelText="Mac Address"
            ></Input>
          </div>
          <div className=" w-full ">
            <select
              value={protocol}
              className="w-full text-sm bg-gray_100 border-[1px] text-[16px] text-gray_600 font-semibold outline-none border-light_blue_800 font-montserrat h-[66px] md:h-[auto] rounded-[10px]"
            >
              <option value="COMMUNICATION_INTERFACE_MQTT">
                COMMUNICATION_INTERFACE_MQTT
              </option>
            </select>
          </div>
        </div>
        <Text className="font-bold text-[18px]">Add Imid Meter</Text>
        {meter?.map((device, index) => (
          <div key={index}>
            {meter?.length > 1 ? (
              <h4 className="font-bold mt-4 mb-2">Meter {index + 1}</h4>
            ) : (
              <h4 className="font-bold mt-4 mb-2">Meter</h4>
            )}
            <div className="customer-form-wrapper mb-4">
              <div>
                <Input
                  wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
                  className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
                  labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
                  name="device-id"
                  value={device.deviceId}
                  disabled={true}
                  labelText="Device Id"
                ></Input>
                <Input
                  wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
                  className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
                  labelClass="relative text-sm text-gray-500 dark:text-blue-500 peer-focus:dark:text-blue-500"
                  name="serialNumber"
                  value={device.deviceAddress}
                  disabled={true}
                  type="number"
                  labelText="Device Address"
                ></Input>
              </div>
              <div>
                <Input
                  wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
                  className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
                  labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
                  name="tariff"
                  value={device.tariff}
                  disabled={true}
                  labelText="Tariff"
                ></Input>
                <div className="w-full">
                  <select
                    value={device.deviceModel}
                    className="w-full text-sm bg-gray_100 border-[1px] text-[16px] text-gray_600 font-semibold outline-none border-light_blue_800 font-montserrat h-[66px] md:h-[auto] mt-[25px] rounded-[10px] py-[11px]"
                    disabled
                  >
                    <option value="2">ACCUREV1300</option>
                    <option value="3">ACCUREV1400</option>
                    <option value="4">EKM-OMULv4</option>
                    <option value="5">EKM-OMIIULv3</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        ))}
        {tenant.length > 0 && (
          <Text className="font-bold text-[18px]">Add Tenant</Text>
        )}
        {updatedTenant?.map((user, index) => (
          <div key={index}>
            {tenant?.length > 1 ? (
              <h4 className="font-bold mt-4 mb-2">Tenant {index + 1}</h4>
            ) : (
              <h4 className="font-bold mt-4 mb-2">Tenant</h4>
            )}

            <div className="customer-form-wrapper">
              <div>
                <Input
                  wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
                  className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
                  labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
                  name="name"
                  value={user?.tenantName}
                  disabled={true}
                  onChange={(e) => setName(e.target.value)}
                  labelText="Tenant Name"
                ></Input>
                <Input
                  wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
                  className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
                  labelClass="relative text-sm text-gray-500 dark:text-blue-500 peer-focus:dark:text-blue-500"
                  name="phoneNumber"
                  value={user?.tenantPhoneNumber}
                  disabled={true}
                  type="number"
                  labelText="Tenant Phone Number"
                  //   required={true}
                ></Input>
              </div>
              <div>
                <Input
                  wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
                  className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
                  labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
                  name="emailAddress"
                  disabled={true}
                  value={user?.tenantEmailAddress}
                  onChange={(e) => setEmailAddress(e.target.value)}
                  labelText="Tenant Email"
                ></Input>
                <Input
                  wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
                  className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
                  name={`Billing Date`}
                  type="date"
                  value={user?.billingStartDate}
                  labelText="Billing Start Date"
                  // onChange={(e) =>
                  //   setStartBillingDate(e.target.value)}
                />
              </div>
            </div>
          </div>
        ))}

        <p className="text-[red] mt-3 text-[12px]">{error}</p>
      </form>
      <div className="mt-4 flex">
        <Button
          onClick={goBack}
          className="border-[1px] border-light_blue_800 bg-white cursor-pointer font-extrabold h-[64px] mb-[20px] px-[7px] sm:px-[15px] sm:py-[5px] rounded-[10px] text-[14px] text-center text-light_blue_800 w-[150px]"
        >
          Back
        </Button>
        <div>
          {!isLoading ? (
            <Button
              onClick={handleSubmit}
              className="bg-light_blue_800 ml-4 cursor-pointer font-extrabold h-[64px] mb-[20px] px-[7px] sm:px-[15px] sm:py-[5px] py-[10px] rounded-[10px] text-[14px] text-center text-white_A700 w-[150px]"
            >
              Submit
            </Button>
          ) : (
            <Button className="bg-light_blue_800 ml-4 cursor-pointer font-extrabold h-[64px] mb-[20px] px-[7px] sm:px-[15px] sm:py-[5px] py-[10px] rounded-[10px] text-[14px] text-center text-white_A700 w-[150px]">
              <ClipLoader color="#fff" size={20} />
            </Button>
          )}
        </div>
      </div>
      <div className="mt-4">
        <Button
          onClick={cancel}
          className="border-[1px] border-light_red_800 bg-[red] cursor-pointer font-extrabold h-[64px] mb-[20px] px-[7px] sm:px-[15px] sm:py-[5px] rounded-[10px] text-[14px] text-center text-white w-[150px]"
        >
          Cancel
        </Button>
      </div>
      {/* <Button type='submit' className="bg-light_blue_800 cursor-pointer font-extrabold h-[64px] mb-[20px] px-[7px] sm:px-[15px] sm:py-[5px] py-[10px] rounded-[10px] text-[14px] text-center text-white_A700 w-[150px]">
              {loading ? (
                <ClipLoader size={20} color={"#ffffff"} />
              ) : (
                "Add Customer"
              )}
            </Button>*/}
    </div>
  );
};

export default AddTenantSummary;
